<div class="layout-container" [ngClass]="containerClass">
    <!-- <app-topbar></app-topbar>  -->
     <app-sidebar></app-sidebar>
    <div class="layout-content-wrapper">
        <div class="layout-content">
            <div class="flex justify-content-between">
                <app-breadcrumb style="align-content: end;"></app-breadcrumb>
                <app-topbar></app-topbar>
            </div>
            
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-profilemenu></app-profilemenu>

    <div class="layout-mask"></div>
</div>
